"use strict";
exports.__esModule = true;
var md5 = require("blueimp-md5");

var MySocket = /** @class */ (function () {
    function MySocket() {
        var _this = this;

        this.OnOpen = function () {
            _this.OpenInterval();
        };

        this.OnError = function () {
            _this.Start();
        };

        this.OnMessage = function (e) {
            var redata = JSON.parse(e.data);
            if (redata.hasOwnProperty('code') && redata.code != 200) {
               
            }
            if (redata.hasOwnProperty('MsgType') && redata.hasOwnProperty('Data')) {
    
                _this.action[redata.MsgType] && _this.action[redata.MsgType](redata.Data);
            }
        };

        this.OnClose = function (e) {
            _this.CloseInterval();
        
        };

        this.Authen = function (res) {
            _this.id = res.client_id;
            var ran = Math.floor(Math.random() * Math.pow(10, 20)).toString();
            var data = {
                MsgType: 'auth',
                token: '',
                string: ran,
                time: new Date().getTime(),
                app_id: 'csgoskins'
            };
            var temp = _this.id + ran + data.time + data.app_id + 'h2T*V%&cQx6traMr';
            data.token = md5(temp);
            _this.isAuthen = true;
            _this.Send(JSON.stringify(data));
        };

        this.OpenInterval = function () {
            var time = 0;
            var dur = 200;
            var heart = 15000;
            _this.timer = setInterval(function () {
                time += dur;
       
                if (_this.isAuthen && _this.event.length > 0) {
                    _this.event[0](_this.id);
                    _this.event.splice(0, 1);
                }
        
                if (time > heart) {
                    time = 0;
                    _this.Send('z');
         
                }
            }, dur);
        };

        this.CloseInterval = function () {
            _this.timer && clearInterval(_this.timer);
            _this.timer = null;
        };

        this.wsurl = 'ws://api.999skins.com/ws';
        this.action = {};
        this.event = [];
        this.Add('connect', this.Authen);
    }

    MySocket.prototype.Add = function (name, func) {
        if (!this.action[name])
            this.action[name] = func;
        return this;
    };

    MySocket.prototype.Event = function (func) {
        this.event[this.event.length] = func;
        return this;
    };

    MySocket.prototype.Remove = function (name) {
        if (this.action[name])
            delete (this.action[name]);
        return this;
    };

    MySocket.prototype.Test = function () {
        for (var key in this.action) {
            if (Object.prototype.hasOwnProperty.call(this.action, key)) {
                if (key != 'connect')
                    this.action[key]();
            }
        }
    };

    MySocket.prototype.Start = function () {
        this.websock && this.Close();
        this.websock = new WebSocket(this.wsurl);
        this.websock.onmessage = this.OnMessage;
        this.websock.onopen = this.OnOpen;
        this.websock.onerror = this.OnError;
        this.websock.onclose = this.OnClose;
        this.isAuthen = false;
    };

    MySocket.prototype.Send = function (data) {
        this.websock.send(data);
    };

    MySocket.prototype.Close = function () {
        this.action = {};
        this.event = [];
        this.websock && this.websock.close();
    };
    return MySocket;
}());
exports["default"] = {
    install: function (Vue) {
        Object.defineProperty(Vue.prototype, '$socket', {
            value: new MySocket(),
            writable: false
        });
    }
};
